import { web } from "./middleware";

export const GoalsAndTargetsApi = {
  getGoals: (params) => web({ url: "/user/goals", method: "GET" }, params),
  getReflections: (userGoalId) =>
    web({ url: `/user/goal/reflection/${userGoalId}`, method: "GET" }),
  getGoalOverview: (params) =>
    web({ url: "/user/goal/overview", method: "GET" }, params),
};
